import {
  Layer,
  PlateIngredientDTO,
  ProteinFormulation,
  LayerDTO,
  AnnotationsDTO,
  ScoresOfWellDropsDTO,
  ScribblesDataDTO,
  LayerDetailsDTO,
  WellIngDTO,
  DropDTO,
  IngredientDTO,
  RandomLayerIngredientGroupDTO,
  RandomLayerGroupIngredientDTO,
  IngredientStockDTO,
  ConditionDTO,
  ScreenLotDTO,
  ScreenDTO,
  ProteinLayerProteinFormulationDTO,
  ProteinFormulationDTO,
  CreateNewTreeNodeDTO,
  WellLayerIngredientDTO,
  RegionAnnotationDTO,
  RegionRulerDTO,
  ROIDTO,
  RegionPointDTO,
  RegionsDTO,
  InspectionSetDTO,
  SystemTaskResultDTO,
  TreeNodeDTO,
  IISOWellDropScoreDTO,
  NavigatorImagesResponseDTO,
  FileResponse,
} from './Models';
import React from 'react';
import { LayerType } from 'utils/Global';
import PlateDtoClient from './PlateDtoClient';
import EScoreType from 'enums/EScoreType';

import { DrawingLayer } from 'business/models/DrawingLayer';
import EViewType from 'enums/EViewType';
import { TreeControlState } from 'components/explorer';
import { WithTabBackButtonStateProps } from 'components/tab';
import ELayersView from 'enums/ELayersView';
import { Plate, WellLayer } from 'components/Experiment/constants';
import { EFetchingStatus } from 'enums/EFetchingStatus';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import { Rectangle } from 'components/canvas/constants';
import { FmlxTable } from 'fmlx-common-ui';
type TreeNodeState = {
  expanded: boolean;
};

export interface RMLine {
  startX: number;
  startY: number;
  endX: number;
  endY: number;
  fillColor?: string;
  bColor?: string;
  strokeWidth?: number;
  opacity?: number;
}

export interface RMRectangle {
  x: number;
  y: number;
  w: number;
  h: number;
  fillColor?: string;
  bColor?: string;
  strokeWidth?: number;
  listening?: boolean;
  opacity?: number;
  rectDesign?: any;
}

export interface WellRectangle extends RMRectangle {
  wellData?: WellIngDTO;
  type?: string;
  ingredientStockId?: number;
}

export interface DropRectangle extends RMRectangle {
  identifier?: ERectangleIdentifiers;
  dropNumber?: number;
}

export type TextProps = {
  x: number;
  y: number;
  w: number;
  h: number;
  size: number;
  name: string;
  color?: string;
};
export type DetailTextProps = TextProps & {
  stroke?: string;
  align?: string;
  strokeWidth?: number;
  fill?: string;
};

export type RMRectProps = {
  x: number;
  y: number;
  w: number;
  h: number;
  bcolor?: string;
  fillcolor?: string;
};

export class AnnotationClientDTO extends RegionAnnotationDTO {
  zIndex?: number;
}
export class ScribbleClientDTO extends ScribblesDataDTO {
  zIndex: number;
  id?: number;
  points?: number[];
}
export class RulerClientDTO extends RegionRulerDTO {
  zIndex: number;
}
export class ROIClientDTO extends ROIDTO {
  zIndex?: number;
  locked: boolean;
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  dropNumber?: number;
  regionId?: number;
}
export class POIClientDTO extends RegionPointDTO {
  zIndex: number;
  locked: boolean;
}

export interface ExperimentCanvasProps {
  expid?: number;
  widthMainDiv?: number;
  selectedTab?: any;
  setCanvasRefs?: any;
  loadingDetails: string[];
  canvasWidth?: number;
  canvasHeight?: number;
  openedSideBars?: number;
  isLayerDrawingMode?: boolean;
  onSelectScreen?: (addScreenLayerFunction) => void;
  onSelectProtein?: (addProteinLayerFunction) => void;
  onLayerResize?: (resizeLayer) => void;
  onIncreaseLayersSize?: (increaseLayersSize) => void;
  setZoomInvocker?: (functionDelegate) => void;
  setRefresh: any;
  canvasNeedsRerendering?: boolean;
  selectedTabName?: string;
  isCanvasNeedsRerender?: () => boolean;
  clearCanvasNeedsRerender?: () => void;
  isScreenRoute?: boolean;
  drawingLayerType?: string;
  changeShowLayers?: (boolean?) => void;
  showOptimize: boolean;
  setShowOptimize: (boolean) => void;
  reportType: string;
  setReportType: (e: string) => void;
  generateRequired?: boolean;
  setGenerateRequired?: (val: boolean) => void;
  setSelectedSidePanelTab?: (val: number | string) => void;
}

export interface LabelDto {
  id: number;
  wellNumber?: number;
  name: string;
}

export interface PlateRendererProps {
  isScreen: boolean;
  mode: string;
  plateNumber: number;
  canvasRefs: any;
  grpRef: any;
  zoomLevel: number;
  isWellSelectionMode: boolean;
  plateId?: number;
  selectedDropNumber?: number;
  plate: Plate;
  shouldShowIngredients?: boolean;
  strokeNormalizer: number;
}
export class TreeNodeExpanded extends TreeNodeDTO {
  public state?: TreeNodeState;
  public sublevel?: number;
  public children?: any;
}

export type BaseTreeProps = {
  treenodes: any[];
  handleChange: (treeNodes) => void;
  mainHeight: string;
  generateNode: (a, b) => React.ReactNode;
  shouldRenderNode?: (node: any) => boolean;
  expandedTreeNodeIds?: Array<number>;
  treeControlState: TreeControlState;
  backgroundColor: string;
  scrollToId?: number;
  containerRef: React.RefObject<HTMLDivElement>;
  isLoading?: boolean;
  isSearchEnabled?: boolean;
};

export type ExpeirmentNodeProps = {
  data: TreeNodeExpanded;
  selectedNode?: any;
  onClickHandler?: (node) => void;
  openDocument?: (node?) => void;
  rest?: any;
  onClickNodeChildren?: (node) => void;
};

export type TreeNodeProps = {
  data: TreeNodeExpanded | ExperimentPlateNodeProps;
  selectedNode?: any;
  onClickHandler?: (node) => void;
  openDocument?: (event?, e2?) => void;
  onClickNodeChildren?: (node) => void;
  draggable?: boolean;
  onDragStart?: (e) => void;
  openedTreeNodes?: string[];
  style?: any;
  onCheckboxChange?: (nodeid: number) => void;
  treeControlState?: TreeControlState;
  backgroundColor?: string;
  onDoubleClick?: (TreeNodeExpanded) => void;
};

export type MainHeaderProps = {
  selectedNodes: TreeNodeDTO[];
  OpenClickHeader: () => void;
  changeAddPanel?: () => void;
  openWizard?: () => void;
  activeDropDown?: string;
  changeActiveDropDown?: (val) => void;
  commonTreeNodes?: any;
  gSelectedNode?: any;
  setCommonTreeNodes?: (val) => void;
  treeNodes?: any[];
  setViewType: (view: EViewType) => void;
  children?: React.ReactNode;
  selectedParentNode: TreeNodeDTO;
  treeNodesFilterQuery: string;
  setTreeNodesFilterQuery: (query: string) => void;
  newFolderType: ETreeNodeTypes;
};

export type renameNodeDTO = {
  id: number;
  newName: string;
};

export type TileViewProps = {
  viewNodes?: any;
  nodes: any;

  nodeClickHandler: (
    link: string,
    node: TreeNodeDTO,
    id: string,
    expanded: boolean,
    inputNodeName: string,
    eventDetail?: number,
  ) => void;
  crumbs: any;
  createNewNode: any;
  onClickNodeChildren: (node: TreeNodeExpanded) => void;
  onDoubleClick: (node: TreeNodeExpanded) => void;
  refreshNode: (node: any) => void;
  refreshTreeNodeAfterRename: (node: renameNodeDTO) => void;
  setSelectedBasePanelNode?: (val) => void;
  treeControlState: TreeControlState;
  setTreeControlState: (val: TreeControlState) => void;
  treeNodesFilterQuery?: string;
};
export type TileTreeNodesProps = {
  node: any;
  nodeClickHandler: (
    link: string,
    node: TreeNodeDTO,
    id: string,
    expanded: boolean,
    inputNodeName: string,
    eventDetail?: number,
  ) => void;
  selectedNodes: any[];
  onClickNodeChildren: (node: TreeNodeExpanded) => void;
  openDocument: (node: TreeNodeExpanded) => void;
  onDoubleClickHandler: (node: TreeNodeExpanded) => void;
  refreshNode: (node: any) => void;
  refreshTreeNodeAfterRename: (node: any) => void;
  onDeleteCompletion: (nodeParentId: any) => void;
  setSelectedBasePanelNode?: (val) => void;
  treeControlState: TreeControlState;
  setTreeControlState: (val: TreeControlState) => void;
  treeNodesFilterQuery?: string;
};

export type ExperimentPlateNodeProps = {
  id: number;
  sortOrder?: number;
  extra?: any;
  plateNumber: number;
  barcode: string;
  type: string;
  name: string;
  state: TreeNodeState;
};

export type CustomCardProps = {
  cardBtn?: React.ReactNode;
  cardStyle;
  title: React.ReactNode;
  headerStyle;
  children;
};

export type ModuleStatusProps = {
  title: string;
  value: string;
};

export type CardHeaderProps = {
  icon: string;
  text: string;
};

export class TargetLayer {
  volume: number;
  waterVolume: number;
  sourceWellId: number;
  sourceWellConditionNumber: string;
  layer: LayerDTO;
  layerId: number;
  targetLayerIngredientList: TargetLayerIngredient[] = [];
  hasError = false;
  error = '';
}
export class WellDropLayer {
  wellDropId: number;
  layerId: number;
  volume: number;
  waterVolume: number;
  waterSource?: number;
  dropWellVolume: number;
  dropProteinVolume: number;
  dropSeedVolume: number;
}

export class TargetLayerIngredient {
  volume: number;
  ingredientTypeIsBuffer: boolean;
  color: number;
  hexColor: string;

  lowPHVolume: number;
  highPHVolume: number;

  ingredientIngredientTypeId: number;
  ingredientStockIngredient: IngredientDTO | undefined;

  ingredientStockId: number;
  ingredientStock: IngredientStockDTO;

  concentration: number;
  preMixedConcentration: number;
  pH: number;

  highPhIngStockId: number;
  highPhIngStock: IngredientStockDTO | undefined;

  stockConcentration: number;
  isBuffer: boolean;

  ingredientTypeColorGroupId: number;
  ingredientTypeId: number;
  ingredientTypeName: string;
  ingredientIngredientTypeIsBuffer: boolean;
}

export class ProteinFormulationClient extends ProteinFormulation {
  treeNodeName: string;
}
export class LayerClient extends Layer {
  type = LayerType.Protein;
  targetDrop: number;

  wellDropVolumeVaryAlong: number;
  proteinDropVolumeVaryAlong: number;

  startWellDropVolume: number;
  stopWellDropVolume: number;
  startProteinDropVolume: number;
  stopProteinDropVolume: number;
}
export type ProjectNodeProps = ExpeirmentNodeProps & {
  newNode: (a, b, c, d) => void;
  onContextMenuClick: (e, node, p) => void;
  onRefreshTreeNode: (node, updateTileView?) => void;
  newFolderType: any;
  isShowContext?: boolean;
  onCheckboxChange?: (nodeid: number) => void;
  treeControlState?: TreeControlState;
  backgroundColor?: string;
  externalDragHandling?: boolean;
  onDoubleClick?: (node: TreeNodeExpanded) => void;
};

export type WithContextProps = ExpeirmentNodeProps & {
  children?: any;
  menu: any;
  draggable?: boolean;
  onDragStart?: (e) => void;
  rest?: any;
  key?: any;
};

export interface CommandPanelsState {
  ingredientInfo: boolean;
  imagingSettings: boolean;
  layerDesign: boolean;
  navigator: boolean;
  plateInfo: boolean;
  requiredStock: boolean;
  focusLevel: boolean;
  imagingSchedule: boolean;
  proteinLayer: boolean;
  screenlayer: boolean;
  imageNow: boolean;
  imageTuning: boolean;
  lots: boolean;
}

export type ExperimentInfoProps = {
  changePanelsState: () => void;
  wellLables: LabelDto[];
  panelsState: CommandPanelsState;
  widthMainDiv: number;
  setExpNameHeader: () => void;
  setHeader: (e) => void;
  setRefresh: () => void;
  openedSideBars: number;
  match: any;
  isScreenRoute: boolean;
  setIsInfoLoaded: (flag: boolean) => void;
};

export type ExperimentHeaderProps = {
  expName: string;
  panelsState: CommandPanelsState;
  headerType: string;
  isDirty: boolean;
  accessRightName: string;
  showLayers: boolean;
  isDropImageAvailable: boolean;
  openedSidebars: number;
  pathName: string;
  regions: RegionsDTO[];
  setReportType: (e: string) => void;
  setShowOptimize?: (e: boolean) => void;
  onDiscardButtonClick: (e) => void;
  deleteSelectedInspection: () => void;
  setShowSeedFormulation?: (e: boolean) => void;
  saveImageClick: () => void;
  changeIconPanels: (e) => void;
  saveExperiment: (e) => void;
  changeCompareMode: (e) => void;
  editExperimentClick: () => void;
  setImageView: (e?) => void;
  setScoreView: (e?) => void;
  sidePanelHandlers: React.ReactNode;
  exportPoi: () => void;
  deleteInspection: () => void;
  printBarcode: () => void;
  isPasteNotAllowed: boolean;
  isHeaderButtonsDisabled: boolean;
  setRegionImaging: (e) => void;
  rotateCanvas: () => void;
  markAsDispensed: () => void;
  exportFrapDataPoints: () => void;
  disableFrapExport?: boolean;
  disablePrintBarcode?: boolean;
  breadCrumbs: TreeNodeDTO[];
  inspections: InspectionSetDTO[];
  isImagedExperiment: boolean;
  isResourceAvailable: boolean;
};

export type ExpCommandPanelsProps = {
  panelsState: CommandPanelsState;
  changePanelsState: (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => void;
  payload?: any;
  onDblScreen?: (id, target, lotNumber) => void;
  onDblProtein?: (id, target, lotNumber) => void;
  onDblCustom?: (id, target, lotNumber) => void;
  onDblSeed?: (id, target, lotNumber) => void;
  wellLables?: LabelDto[];
  isScreenRoute?: boolean;
  openedIconPanel?: string;
  changeIconPanels?: (e) => void;
  showLayers?: boolean;
  changeShowLayers?: () => void;
  selectedLayer?: LayerDTO;
  containerMaxDropVolume?: number;
  containerMaxWellVolume?: number;
  updateRoute?: (url: string) => void;
  getOrignalLayers?: () => LayerDTO[];
  roi?: any;
  forceFetch?: number;
};

export interface RMWCanvasProps {
  draggable?: boolean;
  isDrawingActive?: boolean;
  onDrop?: (e) => void;
  onClick?: (e) => void;
  onDblClick?: (e) => void;
  onMouseEnter?: (e) => void;
  onMouseLeave?: (e) => void;
  onKeyPress?: (e) => void;
  setZoomInvocker?: (e) => void;
  onZoomChange?: (stage, scale, newScale, bestFit?: boolean) => void;
  onMouseDown?: (e) => void;
  onMouseUp?: (e) => void;
  onMouseMove?: (e) => void;
  onWheel?: (e) => void;
  getNewScale?: (newScale: number, zoomIn: number) => number;
  getNewPos?: (newScale: number, newPoints: Points) => Points;
  getNewPositionForScroll?: (newScale: number, newPos: Points) => Points;
  getValidZoomOutScale?: (newScale: number, oldScale: number) => number;
  stageRef?: (sRef, lRef, lRef2, eLRef, eLIRef) => void;
  stage?: any;
  children?: React.ReactNode;
  canvasWidth?: number;
  canvasHeight?: number;
  openedSideBars?: number;
  width?: number;
  height?: number;
  cols?: number;
  rows?: number;
  expId?: number;
  maxCanvasWidthPercentage?: number;
  adjustXonCanvasSizeUpdate?: number;
  canvasStageId?: string;
  canvasStageContainerId?: string;
  showScoresToolTip?: boolean;
  initialStageScale?: number;
  isZoomLocked?: boolean;
  wellSelectionContent?: React.ReactNode;
  minZoomLevel?: number;
  handleZoomAreaSelected?: (zoomArea: Rectangle) => void;
  onDragOver?: (e) => void;
  onDragLeave?: (e) => void;
  fixedContent?: React.ReactNode;
  cursorClass?: string;
}

export interface AnnotationLoaderProps extends PlateRendererProps {
  key: number;
  response: AnnotationsDTO;
  setResponse: (response: AnnotationsDTO) => void;
  render: ({
    plate,
    scores,
    wellNumsContainingScribbles,
    scribbles,
    annotations,
    roi,
    disabledImages,
    histogramImages,
  }: AnnotationLoaderDetailsProps) => JSX.Element;
  params: PlateRendererParams;
}

export interface PlateRendererParams {
  zoomLevel: number;
  plateDTO: PlateDtoClient;
  visibleColStart: number;
  visibleColEnd: number;
  visibleRowStart: number;
  visibleRowEnd: number;
  rows: number;
  cols: number;
}

export interface AnnotationLoaderDetailsProps {
  plate: Plate;
  scores: ScoresOfWellDropsDTO[][];
  wellNumsContainingScribbles: number[];
  scribbles: ScribblesDataDTO[];
  annotations: number[];
  roi: number[];
  disabledImages: number[];
  histogramImages: number[];
  dropNumber: number;
}

export interface ScoreViewProps {
  plate: Plate;
  scoresDetail: ScoresOfWellDropsDTO[][];
}

export interface Points {
  x: number;
  y: number;
}
export type NavItemProps = {
  onClick?: () => void;
  style?: any;
  icon: any;
  label: string;
  to: string;
  isDisabled?: boolean;
  activeClass?: string;
};

export type ExpandSideItemProps = {
  isOpen: boolean;
  icon: any;
  onNavItemClick: (e) => void;
  navItemVal: string;
  navItemText: string;
  isDisabled?: boolean;
};

export type TreeCommandCardProps = {
  iconName: string;
  title: string;
  loadImageIcon?: any;
  onClick?: (e) => void;
  children?: any;
  active?: boolean;
  customStyle?: any;
  customTextStyle?: any;
};

export type ToolsCommandCardProps = {
  iconName: string;
  title: string;
  loadImageIcon?: any;
  onClick?: (e) => void;
  children?: any;
  active?: boolean;
  customStyle?: any;
  customTextStyle?: any;
};

export class StockH2O {
  ingredientStockId: number;
  stockConcentration: number;
  concentrationUnits: string;
  name: string;
  id: number;
  pH: number;
  stockNumber: number;
  vendorpartnum: number;
  volume: number;
}

export class RequiredStockData {
  H2O: StockH2O;

  constructor() {
    this.H2O = new StockH2O();
  }
}

export type TreeControlProps = {
  setParentSelectedNode?: (val) => void;
  openClicked?: number;
  dataSupplier?: any;
  setTreeControlState?: any;
  treeControlState?: TreeControlState;
  setSelectedBasePanelNode?: any;
  treeNodeIdToLoadTree?: number;
  shouldRenderNode?: (node: TreeNodeDTO) => any;
  render?: (
    treeNodes,
    viewNodes,
    newNode,
    clickNodeChildren,
    doubleClick,
    generateNode,
    handleChange,
    loadingDiv,
    crumbs,
    selectedNodeContainer,
    refreshTreeNode,
    refreshTreeNodeAfterRename,
  ) => void;
  selectedTarget?: number;
  onClickNode?: (val) => void;
  globalTreeNodes?: any;
  setParentNode?: any;
  setCommonTreeNodes?: (e) => void;
  commonTreeNodes?: TreeNodeDTO[];
  gSelectedNode?: any;
  setgSelectedNode?: (val) => void;
  addNewNode?: (val: CreateNewTreeNodeDTO) => void;
  disableOpen?: boolean;
  setTreeNodesRef?: (val: any) => void;
  isSetCommon?: boolean;
  isShowContext?: boolean;
  experimentID?: number;
  showQuickAccessNode?: boolean;
  onNodeSelect?: (...args) => any;
  onCheckboxChange?: (nodeid: number) => void;
  backgroundColor?: string;
  allowedRootTreeNodeTypes?: string[];
  shouldListenToBroadcastedEvents?: boolean;
  showRecycleBinNode?: boolean;
  defaultFirstSelectedNode?: ETreeNodeTypes.Projects | ETreeNodeTypes.Screens;
  onNodeClickSelectPostAction?: (node: TreeNodeDTO) => void;
  selectAllNodes?: () => void;
  externalDragHandling?: boolean;
  nodeDoubleClickHandler?: (node: TreeNodeExpanded) => void;
  isSearchEnabled?: boolean;
};

export type WellDetailsStates = {
  cpID: number;
  wellNum: number;
  plateID: number;
  inspectionSet?: InspectionSetDTO;
  dropNumber: number;
  regionName: string;
  totalWells?: number;
  plateNum: number;
  imageBatchId?: number;
  regionID?: number;
};

export type CurrentWellDetails = {
  currentPlate: number;
  currentWell: number;
};

export class SeedLayerDTO extends LayerDetailsDTO {
  id: number;
  startSeedDropVolume: number;
  stopSeedDropVolume: number;
  seedDropVolumeVaryAlong: number;
  seedId: number;
  experimentId: number;
  layerName: string;
  seedName: string;
  seedSeedLayerId: number;
}
export class ProteinLayerDetailsDTO extends LayerDetailsDTO {
  startProteinDropVolume: number;
  stopProteinDropVolume: number;
  proteinFormulationId: number;
  proteinDropVolumeVaryAlong: number;
  layerName: string;

  wellVolumeVaryAlong: number;
  wellStartDropVolume: number;
  wellStopDropVolume: number;
}

export class GridLayerDetailsDTO extends LayerDetailsDTO {
  public gridId?: number;
  public subGridNumber?: number;
  public ingId?: number;
  public ingStockId?: number;
  public startConc?: number;
  public stopConc?: number;
  public concVaryAlong?: number;
}

export class ProteinLayerProteinFormulationDetailsDTO extends ProteinLayerProteinFormulationDTO {
  proteinFormulation?: ProteinFormulationDTO;
}

export type ScoringWell = {
  isDeleteScore: boolean;
  wellNumber: number;
  plateId: number;
  wellDropScoreId: number;
  wellDropScoreGroupId: number;
  isAutoScore: boolean;
  imageBatchId: number;
  dropNumber: number;
  scoreType?: EScoreType;
};

export type ProjectMenuItemProps = {
  isDisabled: boolean;
  icon: any;
  label: string;
  onClick?: any;
};

export type ConditionCardProps = {
  condition: ConditionDTO;
  setContentView: (abc: any) => void;
  setEditIngredientData?: any;
  setSelectedIngredient: any;
  delConditionDelegate?: any;
  copyConditionDelegate?: any;
  pasteConditionDelegate?: any;
  buffer?: ConditionDTO;
  insertConditionDelegate?: any;
  swapConditionsDelegate?: any;
  copyActive: boolean;
  refreshUI?: any;
  isEditMode?: boolean;
};

export type Stocks = {
  stockName: string;
  stockCode: string;
  phValue: string;
  additionalInfo: string;
};
export type IngredientDtoClient = {
  name: string;
  type: string;
  color?: string;
  id?: number;
};

export type IngredientCardDto = {
  ingData: IngredientDtoClient;
  ingConcentration: string;
  ingStock: string;
  id: number;
  ph: any;
  type: string;
};

export type IngredientCardProps = {
  ingredientData?: any;
  ingName?: string;
  ingConcentration?: number;
  ingStock?: string | number;
  customStyle?: any;
  onEditIngredient?: any;
  onDeleteIngredient?: any;
  ingColor?: any;
  id?: any;
  ingStockUnit?: any;
  ingredientId?: any;
  stockNumber?: any;
  setEditIngredientData?: any;
  setContentView?: any;
  setSelectedIngredient?: any;
  weight?: number;
  probability?: number;
  showColor?: boolean;
  isEditMode?: boolean;
  disabled?: boolean;
};
export type ScreenCardProps = {
  screenName?: string;
  lotComments: string;
  conditions: number;
  usedConditions: number;
  customStyle?: any;
  isEditMode?: boolean;
  onEditScreen?: any;
  onDeleteScreen?: any;
};

export type SeedCardProps = {
  layerData?: any;
  seedName?: string;
  seedConcentration?: number;
  seedStock?: string | number;
  style?: any;
  onEditSeed?: any;
  onDeleteSeed?: any;
  id?: any;
  seedId?: any;
  setEditSeedData?: any;
  editSeedData?: any;
  setContentView?: any;
  setSelectedSeed?: any;
  isEditMode?: boolean;
};

export type ProteinCardProps = {
  style?: any;
  onEditProtein: (e) => void;
  onDeleteProtein: (e) => void;
  layerData?: any;
  selectedPF?: any;
  isEditMode?: boolean;
};

export type LayersIngredientsProps = {
  setContentView: (e) => void;
  setEditIngredientData: (e) => void;
  setSelectedIngredient: (e) => void;
  setSelectedPF?: (e) => void;
  setSelectedStocks: (e) => void;
  randomLyrActiveGroupId?: number;
  setRandomLyrActiveGroupId?: any;
  setEditSeedData?: (e) => void;
  editSeedData?: any;
  setEditScreenData?: (e) => void;
  selectedProteinFormulation?: any;
};

export type LayerProps = {
  onClose?: any;
  layerData?: any;
  contentView?: any;
  setContentView?: any;
  selectedLayerName?: any;
  selectedTab?: any;
  setSelectedTab?: any;
  ingredients?: IngredientCardDto[];
  setActiveIngredients?: (e) => void;
  setEditIngredientData?: any;
  layerType?: any;
  setSelectedIngredient?: (e) => void;
  selectedLayerId?: any;
  layers?: any;
};

export type LayerTarget = WellIngDTO | DropDTO;

export type RandomLayerGroup = {
  id: number;
  probability?: number;
  name: string;
  ingredients?: RandomLayerGroupIngredient[];
};
export type RandomLayerProps = {
  onClose?: any;
  layers: DrawingLayer[];
};
export type RandomLayerIngContainerProps = {
  setContentView: any;
  groups: RandomLayerIngredientGroupDTO[];
  deleteGroup: any;
  setActiveGroupId: any;
  activeGroupId: number;
  contentView?: any;
  deleteIngredientInSelectedGroup?: any;
  addGroup?: any;
  setEditIngredientData?: any;
  layerData: any;
  isEditMode?: boolean;
};
export type RandomLayerIngProps = {
  setContentView: any;
  setEditIngredientData?: any;
  setSelectedIngredient: any;
  setSelectedStocks: any;
  activeGroupId: number;
  setActiveGroupId: any;
};
export type RandomLayerGroupSelectionProps = RandomLayerGroup & {
  active?: boolean;
  deleteGroup: any;
  setActiveGroup: any;
  isEditMode?: boolean;
};

export type RandomLayerGroupIngredient = {
  id: number;
  name: string;
  lowConcentration?: number;
  highConcentration: number;
  concUnit?: string;
  weight?: number;
  probability?: number;
  stock: number;
  stockUnit?: string;
  stockNumber?: string;
  color: string;
};

export type RandomLayerGroupIngredientProps = {
  ing: RandomLayerGroupIngredientDTO;
  probability: number;
  deleteIngredientInSelectedGroup?: any;
  onClickEditIngredient: (ing) => void;
};
export class Point {
  public X: number;
  public Y: number;
  constructor(_x: number, _y: number) {
    this.X = _x;
    this.Y = _y;
  }
}

export type ExcludeIngredientGroup = {
  id: number;
  name: string;
  ingredients?: IngredientDtoClient[];
};

export interface ExcludeIngredientProps extends WithTabBackButtonStateProps {
  setContentView?: any;
  editExcludeGroupId: number;
  setEditExcludeGroupId: any;
  handleBackToPreviousScreen: (contentView: ELayersView) => () => void;
}
export interface GroupProps extends WithTabBackButtonStateProps {
  setContentView?: any;
  activeGroupId: number;
  isEditGroupActive: boolean;
  setRandomLyrActiveGroupId: any;
  setSelectedTab: (val: number) => void;
  handleBackToPreviousScreen: (contentView: ELayersView) => () => void;
  setIsStayOnEditGroup?: any;
}

export type EICheckBoxProps = {
  labelText: string;
  textBoxText: string;
  active?: boolean;
  onClick?: () => void;
  isShowClose?: boolean;
  onClose?: () => void;
};
export type EISelectBoxProps = {
  labelText?: string;
  placeholder?: string;
  selectedValue: any;
  onChange?: (e) => void;
  options: SelectNameValue[];
  disabled?: boolean;
  selectStyle?: any;
  containerStyle?: any;
  labelStyle?: any;
  selectClassName?: string;
  labelClassName?: string;
  containerClassName?: string;
};

export type SelectNameValue = {
  name: string;
  value: number;
};

export type RandomLayerExcludeIngredientProps = {
  setContentView: any;
  setEditExcludeGroupId: any;
};
export type LayerInfoParentProps = {
  setContentView?: any;
  setEditExcludeGroupId?: any;
  containerMaxWellVolume?: number;
  isoRound: number;
  isoPlate: number;
  isoScores: IISOWellDropScoreDTO[];
  isScreenRoute?: boolean;
};

export interface EditIngredientProps extends WithTabBackButtonStateProps {
  setContentView: (val) => void;
  selectStock: IngredientStockDTO;
  selectIngredient: any;
  editIngredientData: any;
  selectHighPHStock: any;
  resetStockValue: () => void;
  handleBackToPreviousScreen: (contentView: ELayersView) => () => void;
  setSelectedTab?: (val: number) => void;
}

export type StockCardProps = {
  stockData: IngredientStockDTO;
  isFavourite: boolean;
  onClick: (val) => void;
  setGlobalFavIngStocks: React.Dispatch<React.SetStateAction<any[]>>;
};

export type RandomWellMap = {
  wellId: number;
  wellPosition: Point;
};

export type TSelectIngredient = {
  id: number;
  name: string;
  shortName?: string;
};

export class ScreenDtoClient extends ScreenDTO {
  public selectedLot: ScreenLotDTO;
}

export type TFocusLevelImage = {
  imageId: number;
  imageTypeId: number;
  image: string;
  imageTitle: string;
  pixelSize: number;
  imageTypeIndex: number;
  imageTypeShortName?: string;
};

export type RequiredStockProps = {
  heading: any;
  onClose: any;
  plate: PlateDtoClient;
};

export type CreateExpOptionsProps = {
  heading: string;
  children?: any;
  style?: any;
  selectedOption: any;
  setSelectedOption: any;
  options: any[];
  placeholder?: string;
  disableSelect?: boolean;
};

export type RMSelectProps = {
  options: SelectType[];
  selectedValue: any;
  onChange: (e) => void;
  style?: any;
  placeholder: string;
  disabled?: boolean;
  className?: string;
  id?: string;
};

export type SelectType = {
  id: any;
  name: string;
};

export type WellNumProps = {
  x: number;
  y: number;
  width: number;
  height: number;
  text: string;
  fontSize: number;
};

export type ScaleBarProps = WellNumProps & {
  scaleBarWidth: number;
  scaleBarHeight: number;
  scale: number;
};

export type CopyWellDetail = {
  id: number;
  wellLayers: WellLayer[];
  x: number;
  y: number;
};

export type ClipboardWellDetails = {
  plateBarcode: string;
  location: string;
  ingredient: string;
  concentration: number;
  unit: string;
  volume: number;
  buffer?: string;
  ph?: any;
};

export type ClipboardSearchResults = {
  plateId: string;
  experimentId: string;
  projectName: string;
  fileName: string;
  plateName: string;
  owner: string;
  barcode: string;
  datePrepared: string;
};

export class ISOPreviousPlateData {
  ingredients: PlateIngredientDTO;
  layers: LayerDTO[];
  scores: ScoresOfWellDropsDTO[][];
}

export type ISOWellIngredientDTO = {
  ingredient: WellLayerIngredientDTO;
  layerName: string;
  wellNumber: number;
};

export type ModalDetails = {
  showModal: boolean;
  setShowModal: () => void;
  onOk: () => void;
  body: any;
  icon?: any;
  titleClr?: string;
  heading: string;
  isOkOnly: boolean;
  okButtonText: string;
  noButtonText?: string;
  showButtons: boolean;
  onCancel?: () => void;
  dialogClassName?: string;
  isCancelOnly?: boolean;
};

export class BatchloadTaskResponseDTO extends SystemTaskResultDTO {
  experimentIds: number[] | undefined;
}

export type CanvasTilesCoords = {
  plateId: number;
  stx: number;
  sty: number;
  endx: number;
  endy: number;
};

export type NavigatorImagesData = {
  status: EFetchingStatus;
  data: NavigatorImagesResponseDTO;
};

export enum ERectangleIdentifiers {
  Drop,
  Well,
}

export enum EJobStatus {
  BeforeStart = 0,
  InProgress = 1,
  Completed = 2,
  Cancelled = 3,
  Error = 4,
}

export type FmlxColumnFilter = {
  type: 'text' | 'dropdown' | 'datepicker' | 'custom' | FmlxTable.FilterType;
  options?: string;
  datepickerVariant?: 'date' | 'time' | 'dateTime';
  minDate?: string;
  maxDate?: string;
  component?: React.ReactNode;
};

export type FmlxColumn = {
  Header: string;
  accessor: string;
  filterDefinition: FmlxColumnFilter;
  editable: boolean;
  disableSort: boolean;
  hideSort: boolean;
  hideFilter: boolean;
  headerStyle: object;
  Cell?: ({ value, row }) => React.ReactNode;
};

export class FileSystemTaskResultDTO extends SystemTaskResultDTO {
  responseFile: FileResponse;
}
